export default __webpack_public_path__ + "static/media/Messer-form.596a6749.png";